import i18n from '@/plugins/i18n'

export default {
    path: '/' + i18n.t('login.routes.index'),
    name: 'login',
    component: () =>
        import(/* webpackChunkName: "login" */ '@/views/auth/Login.vue'),
    meta: {
        layout: 'simple-layout',
        guest: true,
    },
}
